// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SkillLevelDescriptions_container__J0358 {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: var(--gutter);
}
@media (max-width: 768px) {
  .SkillLevelDescriptions_container__J0358 {
    flex-direction: column;
  }
}

.SkillLevelDescriptions_selectContainer__a7hPu {
  display: flex;
  flex-direction: column;
  gap: var(--gutter);
  max-width: 300px;
  background: var(--color-surface-light);
  padding: var(--gutter);
  border-radius: var(--radius-default);
}
@media (max-width: 768px) {
  .SkillLevelDescriptions_selectContainer__a7hPu {
    max-width: unset;
    width: 100%;
  }
}

.SkillLevelDescriptions_descriptionsContainer__aSxtT {
  margin: 0 auto;
  flex: 1 1;
  padding: calc(var(--gutter) * 2);
  background: var(--color-surface-light);
  border-radius: var(--radius-default);
  display: flex;
  flex-direction: column;
  gap: var(--gutter);
}
@media (max-width: 768px) {
  .SkillLevelDescriptions_descriptionsContainer__aSxtT {
    width: 100%;
  }
}

.SkillLevelDescriptions_textareaContainer__8uRm- {
  max-width: 600px;
}

.SkillLevelDescriptions_levelTitle__JTqi5 {
  font-weight: 600;
}

.SkillLevelDescriptions_descriptionTextarea__TNBH1 {
  margin-bottom: 0.25rem;
}

.SkillLevelDescriptions_savingIndicator__lVgXg {
  color: var(--color-text-subtle);
  display: inline-block;
  margin-left: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/components/SkillLevelDescriptions.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AACF;AACE;EAPF;IAQI,sBAAA;EAEF;AACF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sCAAA;EACA,sBAAA;EACA,oCAAA;AAEF;AAAE;EATF;IAUI,gBAAA;IACA,WAAA;EAGF;AACF;;AAAA;EACE,cAAA;EACA,SAAA;EACA,gCAAA;EACA,sCAAA;EACA,oCAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AAGF;AADE;EAVF;IAWI,WAAA;EAIF;AACF;;AADA;EACE,gBAAA;AAIF;;AADA;EACE,gBAAA;AAIF;;AADA;EACE,sBAAA;AAIF;;AAAA;EACE,+BAAA;EACA,qBAAA;EACA,mBAAA;AAGF","sourcesContent":[".container {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: var(--gutter);\n\n  @media (max-width: 768px) {\n    flex-direction: column;\n  }\n}\n\n.selectContainer {\n  display: flex;\n  flex-direction: column;\n  gap: var(--gutter);\n  max-width: 300px;\n  background: var(--color-surface-light);\n  padding: var(--gutter);\n  border-radius: var(--radius-default);\n\n  @media (max-width: 768px) {\n    max-width: unset;\n    width: 100%;\n  }\n}\n\n.descriptionsContainer {\n  margin: 0 auto;\n  flex: 1;\n  padding: calc(var(--gutter) * 2);\n  background: var(--color-surface-light);\n  border-radius: var(--radius-default);\n  display: flex;\n  flex-direction: column;\n  gap: var(--gutter);\n  \n  @media (max-width: 768px) {\n    width: 100%;\n  }\n}\n\n.textareaContainer {\n  max-width: 600px;\n}\n\n.levelTitle {\n  font-weight: 600;\n}\n\n.descriptionTextarea {\n  margin-bottom: 0.25rem;\n\n}\n\n.savingIndicator {\n  color: var(--color-text-subtle);\n  display: inline-block;\n  margin-left: 0.5rem;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SkillLevelDescriptions_container__J0358`,
	"selectContainer": `SkillLevelDescriptions_selectContainer__a7hPu`,
	"descriptionsContainer": `SkillLevelDescriptions_descriptionsContainer__aSxtT`,
	"textareaContainer": `SkillLevelDescriptions_textareaContainer__8uRm-`,
	"levelTitle": `SkillLevelDescriptions_levelTitle__JTqi5`,
	"descriptionTextarea": `SkillLevelDescriptions_descriptionTextarea__TNBH1`,
	"savingIndicator": `SkillLevelDescriptions_savingIndicator__lVgXg`
};
export default ___CSS_LOADER_EXPORT___;
